import React, { useState, useEffect } from "react";
import PlayerControls from "./PlayerControls";
import PlayerOverlay from "./PlayerOverlay"

const calendar = (<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.1667 2.66699H3.83333C3.09695 2.66699 2.5 3.26395 2.5 4.00033V13.3337C2.5 14.07 3.09695 14.667 3.83333 14.667H13.1667C13.903 14.667 14.5 14.07 14.5 13.3337V4.00033C14.5 3.26395 13.903 2.66699 13.1667 2.66699Z" fill="white" stroke="white" strokeWidth="0.888889" strokeLinecap="round" strokeLinejoin="round"/><path d="M11.167 1.33301V3.99967" stroke="white" strokeWidth="0.888889" strokeLinecap="round" strokeLinejoin="round"/><path d="M5.83301 1.33301V3.99967" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M2.5 6.66699H14.5" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const radio = (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99996 9.33268C8.73634 9.33268 9.33329 8.73573 9.33329 7.99935C9.33329 7.26297 8.73634 6.66602 7.99996 6.66602C7.26358 6.66602 6.66663 7.26297 6.66663 7.99935C6.66663 8.73573 7.26358 9.33268 7.99996 9.33268Z" fill="#CE2032" stroke="#CE2032" strokeWidth="0.888889" strokeLinecap="round" strokeLinejoin="round"/><path d="M10.8267 5.17378C11.1986 5.54527 11.4936 5.98642 11.6949 6.47201C11.8962 6.95761 11.9998 7.47811 11.9998 8.00378C11.9998 8.52944 11.8962 9.04995 11.6949 9.53554C11.4936 10.0211 11.1986 10.4623 10.8267 10.8338M5.17335 10.8271C4.80145 10.4556 4.50641 10.0145 4.30512 9.52887C4.10382 9.04328 4.00021 8.52277 4.00021 7.99711C4.00021 7.47145 4.10382 6.95094 4.30512 6.46535C4.50641 5.97976 4.80145 5.5386 5.17335 5.16711M12.7134 3.28711C13.9632 4.53729 14.6653 6.23268 14.6653 8.00044C14.6653 9.7682 13.9632 11.4636 12.7134 12.7138M3.28669 12.7138C2.03688 11.4636 1.33478 9.7682 1.33478 8.00044C1.33478 6.23268 2.03688 4.53729 3.28669 3.28711" stroke="#CE2032" strokeWidth="0.888889" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const chevron = (<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9L5 5L1 1" stroke="white" strokeWidth="0.888889" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const stationIds = {
  1: '961',
  2: '907'
}

const AudioPlayer = ({ lottie }) => {
  const [showPlayer, setShowPlayer] = useState(() => JSON.parse(localStorage.getItem("showPlayer") || "false"));
  const [audioInfo, setAudioInfo] = useState(() => JSON.parse(localStorage.getItem("audioInfo") || "{}"));

  useEffect(() => {
    const handleSync = () => {
      const newInfo = localStorage.getItem("audioInfo");
      const playerStatus = localStorage.getItem("showPlayer");
      if (newInfo) setAudioInfo(JSON.parse(newInfo));
      if (playerStatus !== null) setShowPlayer(JSON.parse(playerStatus));
    };

    window.addEventListener("storage", handleSync);
    return () => window.removeEventListener("storage", handleSync);
  }, []);

  const togglePlayer = () => {
    const nextShow = !showPlayer;
    const playing = JSON.parse(localStorage.getItem("isPlaying") || "false");

    if (!playing && nextShow) {
      localStorage.setItem("isPlaying", "true");
    }

    localStorage.setItem("showPlayer", JSON.stringify(nextShow));
    setShowPlayer(nextShow);
    window.dispatchEvent(new Event("storage"));
  };

  const handleLiveClick = () => {
    fetch("/api/v1/stations")
      .then((res) => res.json())
      .then((body) => {
        const station = body.data.stations.find(st => stationIds[st.id] == audioInfo.id);

        const info = {
          id: station.id == 1 ? "961" : "907",
          name: station.name,
          frequency: station.frequency,
          logo: station.logo,
          live: true,
          src: station.feed_url,
          liveProgram: station.live_program
        };
        localStorage.setItem("audioInfo", JSON.stringify(info));
        localStorage.setItem("isPlaying", "true");
        localStorage.setItem("showPlayer", "true");
        window.dispatchEvent(new Event("storage"));
      })
      .catch(console.warn);
  };

  useEffect(handleLiveClick, []);
  
  const {liveProgram} = audioInfo;
  
  return (
    <div className={`audio-player ${audioInfo.id ? "" : "d-none"}`}>    
      <button onClick={togglePlayer} className={`audio-player__toggle ${showPlayer ? "--colapse" : ""}`}>
        {audioInfo.live && <lottie-player autoplay="true" loop="true" src={lottie}></lottie-player>}
        {audioInfo.live ? "En vivo" : "Podcast"}
        {chevron}
      </button>

      <div className={`audio-player__wrapper ${showPlayer ? "" : "d-none"}`}>
        <div className="audio-player__info">
          <img src={liveProgram ? liveProgram.cover : audioInfo.logo} alt="logo" />
          <div className="audio-player__info__content">
            <span>{audioInfo.live && <>{radio} En Vivo</>}</span>
            <h3 className={liveProgram ? "marquee-text" : ''} data-text={liveProgram ? liveProgram.title : ''}>{liveProgram ? liveProgram.title : audioInfo.name}</h3>
            <span>{audioInfo.frequency} FM</span>
          </div>
        </div>
        <PlayerControls src={audioInfo.src} />
        <div className="audio-player__anchor">
          {!audioInfo.live && (
            <button className="audio-player__anchor__btn d-flex" onClick={handleLiveClick}>{radio} En Vivo</button>
          )}
          <PlayerOverlay station={audioInfo.id} />
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;